import React, {useEffect, useState} from 'react'

import { useTranslation } from 'react-i18next'

import {
Page16Container,
Page16Content,
Page16Head,
Page16HeadCaption,
Page16Wrapper,
Page16ButtonWrapper,
Page16Card,
Page16CardCaption1,
Page16CardCaption2,
Page16CardContainer,
Page16CardImage,
Page16CardText1,
Page16CardText2,
Page16CardWrapper,
Page16InfoButton,
Page16RentButton,
LinkIcon,
} from './rentWearableStyles'

import { 
  Dash2,
  Wrapper2,
  Left2,
  DashLogo2,
  LeftCaption2,
  Link2,
  ProfileInfo,
  WalletAddress,
  DashIcons2,
  Right2,
  DashIconContainer2, 
  UserIcon,
  UserIconContainer,

} from '../../components/dashboardBar2/dashboardBar2Styles'



import image from '../../icons/dashboardBarIcons/BlueLogo.png'
import ResponsiveDashBar from '../../components/ResponsiveBar/ResponsiveDashBar';
import WalletConnect from '../../components/ConnectionNav/Connect';
import profilePicture from '../../assets/Image.svg'
import wearableImage from '../../assets/RectangleImage.png'
import {data} from '../../data'
import WearablePopup from '../../components/PopUps/WearablePopup/WearablePopup'
import ProfileCard from '../../components/PopUps/profileCard/ProfileCard'
import EmailPopup from '../../components/PopUps/EmailPopup/EmailPopup'
import RentalsPopup from '../../components/PopUps/RentalsPopup/RentalsPopup'
import Rentals from '../../icons/dashboardBarIcons/Rentals'
import Message from '../../icons/dashboardBarIcons/Message'
import NotificationIcon from '../../icons/dashboardBarIcons/NotificationIcon.js'
import Notifications from '../../components/PopUps/NotiicationDropDown/NotificationDropDown';




const Page16 = () => {

    const { t } = useTranslation();
    console.log(data);
    const [degree , setDegree] = useState('100%');
    const [profileDisplay, setProfileDisplay] = useState('none');
    const [rentInfoDisplay, setRentInfoDisplay] = useState('none');
    const [messageDisplay, setMessageDisplay] = useState('none');
    const [rentsDisplay, setRentDisplay] = useState('none');
    const [notificationDisplay, setNotificationDisplay] = useState('none');

    const ProfileClick = () => {
        if(profileDisplay === 'none'){
          setProfileDisplay('flex');
          setDegree('50%');
        }else{
          setDegree('100%');
          setProfileDisplay('none');
        }
      }


      const MessageClick = () => {
        if(messageDisplay === 'none'){
          setMessageDisplay('flex');
          setDegree('50%');
        }else{
          setDegree('100%');
          setMessageDisplay('none');
        }
      }
    
      const RentalClick = () =>{
        if(rentsDisplay === 'none'){
          setRentDisplay('flex');
          setDegree('50%');
        }else{
          setDegree('100%');
          setRentDisplay('none');
        }
      }

  const RentClick = () => {
        if(rentInfoDisplay === 'none'){
            setRentInfoDisplay('flex');
            setDegree('50%');
          }else{
            setDegree('100%');
            setRentInfoDisplay('none');
          }
    }

    const NotificationIconClick = () => {
      if(notificationDisplay === 'none'){
        setNotificationDisplay('flex');
        setDegree('50%');
      }else{
        setNotificationDisplay('none');
        setDegree('100%');
      }
    }
  

    const CancelClick = () => {
        setRentInfoDisplay('none');
        setDegree('100%');
    }

    const CancelMessage = () => {
      setMessageDisplay('none');
      setDegree('100%')
    }

    const ClearScroll = () =>{
      setDegree('100%');
      setRentInfoDisplay('none');

    }

    const Clear = () => {
      setDegree('100%')
      setProfileDisplay('none');
      setMessageDisplay('none');
      setRentDisplay('none');
      setRentInfoDisplay('none');
      setNotificationDisplay('none');
    }

  useEffect(() =>{
    if(degree === '50%'){
      window.addEventListener('scroll', ClearScroll );
    }else if(degree === '100%'){
      window.removeEventListener('scroll', ClearScroll);
    }

    const container = document.querySelector('#container')
    if(degree === '50%'){
      container.addEventListener('click', Clear );
      console.log(degree);
    }else if(degree === '100%'){
      container.removeEventListener('click', Clear);
      console.log(degree);
    }
  
  })
  return <>  

    <Page16Container id='container' degree = {degree}> 

        <WalletConnect />
        <Dash2>

              <Wrapper2>
              <Left2>
                  <DashLogo2 src={image} />
                  <LeftCaption2>
                  <Link2>
                  {t("page17.pageName")}
                  </Link2>
                  </LeftCaption2>
              </Left2>
              <Right2>
              <ResponsiveDashBar />
                  <ProfileInfo>
                      <WalletAddress>Mpzi8uaA......yMv</WalletAddress>
                      {t("page5.profileCard.connected")}
                  </ProfileInfo>

                  <DashIcons2>
                  <LinkIcon onClick={ProfileClick}>
                      <UserIconContainer>
                          <UserIcon src={profilePicture} />
                      </UserIconContainer>
                  </LinkIcon>
                  <LinkIcon onClick={RentalClick}>
                      <DashIconContainer2>
                          <Rentals />
                      </DashIconContainer2>
                  </LinkIcon>
                  <LinkIcon onClick={MessageClick}>
                      <DashIconContainer2>
                          <Message />
                      </DashIconContainer2>
                  </LinkIcon>
                  <LinkIcon onClick={NotificationIconClick}>
                        <NotificationIcon />
                  </LinkIcon>
                  </DashIcons2>
                  </Right2>
              </Wrapper2>
        </Dash2>

        <Page16Wrapper>
            <Page16Head>
                    <Page16HeadCaption>
                        {t("page16.caption")} 
                    </Page16HeadCaption> 
            </Page16Head>
        </Page16Wrapper>

            <Page16CardContainer>
                    {
                        data.map(item =>(
                            <Page16Card key ={item.id}>
                            <Page16CardWrapper>
                                    <Page16CardImage src={wearableImage} />
                                    <Page16Content>
                                        <Page16CardCaption1>{item.wariableForRent}</Page16CardCaption1>
                                        <Page16CardCaption2>
                                            <Page16CardText1>{item.levelOrRank} Levels</Page16CardText1>
                                            <Page16CardText2>. {item.multiplier} Multiplier</Page16CardText2>
                                        </Page16CardCaption2>
                                        <Page16ButtonWrapper>
                                            <Page16InfoButton>...</Page16InfoButton>
                                            <Page16RentButton onClick={RentClick}>{t("page5.rentMeButton")}</Page16RentButton>
                                        </Page16ButtonWrapper>
    
                                    </Page16Content>
                            </Page16CardWrapper>
                        </Page16Card>
                        ))
                    }
            </Page16CardContainer>

    </Page16Container>
    <ProfileCard display={profileDisplay} />
    <EmailPopup display={messageDisplay} Cancel={CancelMessage}/>
    <RentalsPopup display={rentsDisplay}/>
    <WearablePopup display={rentInfoDisplay} Cancel={CancelClick}/>
    <Notifications display={notificationDisplay} />
  </>
}

export default Page16